import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    grid: {
      display: 'grid',
      gridTemplateRows: '2fr 1fr',
      columnGap: 134,
      rowGap: Spacings.s24,

      '&.image-from-left': {
        gridTemplateColumns: '5fr 6fr',
        gridTemplateAreas: "'image content' 'image action'",
      },

      '&.image-from-right': {
        gridTemplateColumns: '6fr 5fr',
        gridTemplateAreas: "'content image' 'action image'",
      },
      '&[class*=image-from]': {
        [mediaQuery(1365)]: {
          columnGap: Spacings.s64,
          rowGap: Spacings.s24,
        },
        [mediaQuery(1023)]: {
          gridTemplateColumns: '1fr',
          gridTemplateRows: '1fr',
          gridTemplateAreas: "'image' 'content' 'action'",
        },
      },
    },

    column: {
      minWidth: Spacings.s0,

      '&.image': {
        gridArea: 'image',
        minHeight: 244,
        width: '100%',
        margin: '0 auto',
      },
      '&.content': {
        display: 'flex',
        justifyContent: 'center',
        gridArea: 'content',
        width: '100%',
        alignItems: 'center',
        alignSelf: 'end',
      },
      '&.action': {
        display: 'flex',
        justifyContent: 'left',
        gridArea: 'action',
        alignSelf: 'start',
        width: '100%',
        [mediaQuery(1023)]: {
          marginTop: Spacings.s8,
          justifyContent: 'center',
        },
      },

      '&.content-fallback': {
        flexDirection: 'column',
        '& h2': {
          width: '100%',
          height: 64,
          marginBottom: Spacings.s24,
        },
      },
      '&.button-fallback': {
        width: '50%',
        height: 56,
      },

      [mediaQuery(1023)]: {
        maxWidth: 456,
        margin: [Spacings.s0, 'auto'],
      },
    },

    carouselDots: {
      width: '80%',
      height: 80,
      marginLeft: Spacings.s56,
      [mediaQuery(1023)]: {
        display: 'none',
      },
    },
  }),
  {
    name: 'body-text-with-cta',
  },
);

export default useStyles;
